/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import { isEqual } from 'lodash';
import Types from '../constants/actionTypes';
import Store from '../store/store';
import { updateUserSpaceView } from './userActions';
import { updateUserWorkspace, userTourState } from '../utils/userHelpers';
import { newKanbanFilters } from '../utils/spaceHelpers';

export const populateViewState = (savedViews, previousViews) => (dispatch) => {
  dispatch({ type: Types.POPULATE_SAVED_VIEWS, savedViews, previousViews });
};

export const selectSavedView = (view) => (dispatch) => {
  dispatch({ type: Types.ACTIVATE_SAVED_VIEW, view, level: view.level });
  const {
    previousStates,
    planwallStates,
    savedViews,
    kanbanWallState,
    savedKanbanFilters
  } = Store.getState().savedViewReducer;
  const selectedSpace = JSON.parse(localStorage.selectedSpace);

  const newSavedKanbanFilters = newKanbanFilters(
    selectedSpace,
    savedKanbanFilters,
    kanbanWallState
  );

  dispatch(
    updateUserSpaceView({
      user: {
        saved_space_view: {
          saved_space: selectedSpace,
          planwall_defaults: planwallStates,
          saved_views: savedViews,
          previous_views: previousStates,
          kanban_state: kanbanWallState,
          saved_kanban_filters: newSavedKanbanFilters,
          tourState: userTourState()
        }
      }
    })
  );
};

export const createNewView = (viewName, level) => (dispatch) => {
  const planwall_defaults = Store.getState().savedViewReducer.planwallStates;
  const currentView = planwall_defaults[level - 1].state;
  const selectedSpace = JSON.parse(localStorage.selectedSpace);

  const {
    savedViews,
    previousStates,
    kanbanWallState,
    savedKanbanFilters
  } = Store.getState().savedViewReducer;

  const newView = {
    name: viewName,
    space_id: selectedSpace.id,
    space_type: selectedSpace.type,
    level,
    view: currentView
  };

  const updatedViews = [...savedViews, newView];
  dispatch({ type: Types.SAVED_VIEW_FETCHING });

  const newSavedKanbanFilters = newKanbanFilters(
    selectedSpace,
    savedKanbanFilters,
    kanbanWallState
  );

  dispatch(
    updateUserSpaceView(
      {
        user: {
          saved_space_view: {
            saved_space: selectedSpace,
            planwall_defaults,
            saved_views: updatedViews,
            previous_views: previousStates,
            kanban_state: kanbanWallState,
            saved_kanban_filters: newSavedKanbanFilters,
            tourState: userTourState()
          }
        }
      },
      'create',
      newView
    )
  );
};

export const deleteSavedView = (view) => (dispatch) => {
  const planwall_defaults = Store.getState().savedViewReducer.planwallStates;
  const selectedSpace = JSON.parse(localStorage.selectedSpace);

  const {
    savedViews,
    previousStates,
    kanbanWallState,
    savedKanbanFilters
  } = Store.getState().savedViewReducer;

  const updatedViews = savedViews.filter(
    (savedView) => !isEqual(view, savedView)
  );
  dispatch({ type: Types.SAVED_VIEW_FETCHING });

  const newSavedKanbanFilters = newKanbanFilters(
    selectedSpace,
    savedKanbanFilters,
    kanbanWallState
  );

  dispatch(
    updateUserSpaceView(
      {
        user: {
          saved_space_view: {
            saved_space: selectedSpace,
            planwall_defaults,
            saved_views: updatedViews,
            previous_views: previousStates,
            kanban_state: kanbanWallState,
            saved_kanban_filters: newSavedKanbanFilters,
            tourState: userTourState()
          }
        }
      },
      'delete',
      view
    )
  );
};

export const clearActiveView = () => (dispatch) => {
  dispatch({ type: Types.CLEAR_ACTIVE_VIEW });
};

export const updatePlanwallState = (level, state) => (dispatch) => {
  dispatch({ type: Types.UPDATE_PLANWALL_STATE, level, state });
};

export const checkSavedViewsForCurrentView = (level) => (dispatch) => {
  dispatch({ type: Types.CHECK_SAVED_VIEWS_FOR_CURRENT_VIEW, level });
};

export const populatePlanwallStates = (planwallDefaults) => (dispatch) => {
  dispatch({ type: Types.POPULATE_PLANWALL_STATE, planwallDefaults });
};

export const switchProductTeamColumnView = (columnObject, level) => (
  dispatch
) => {
  dispatch({ type: Types.SWITCH_PRODUCT_TEAM_COLUMNS, columnObject, level });
};

export const updateRightPanelState = (rowState, level) => (dispatch) => {
  dispatch({ type: Types.UPDATE_RIGHT_PANEL_STATE, rowState, level });
};

export const populateKanbanFilters = (kanbanFilters) => (dispatch) => {
  dispatch({ type: Types.POPULATE_KANBAN_FILTERS, kanbanFilters });
};

export const addKanbanFilter = (filterName, value) => (dispatch) => {
  dispatch({ type: Types.ADD_KANBAN_FILTER, filterName, value });
  dispatch(updateUserSpaceView({ user: updateUserWorkspace() }))
};

export const removeKanbanFilter = (filterName, value) => (dispatch) => {
  dispatch({ type: Types.REMOVE_KANBAN_FILTER, filterName, value });
  dispatch(updateUserSpaceView({ user: updateUserWorkspace() }))
};

export const clearKanbanFilter = (filterName) => (dispatch) => {
  dispatch({ type: Types.CLEAR_KANBAN_FILTER, filterName });
  dispatch(updateUserSpaceView({ user: updateUserWorkspace() }))
};

export const resetKanbanFilter = () => (dispatch) => {
  //not in use
  dispatch({ type: Types.RESET_KANBAN_FILTER });
};

export const populateSavedKanbanFilters = (views, selectedSpace) => (
  dispatch
) => {
  dispatch({ type: Types.SET_SAVED_KANBAN_FILTERS, views, selectedSpace });
};
